import { EGeoName } from '../../../types/share';

export function mapRegionValueToAnalytics(value: EGeoName) {
  const mapper = {
    [EGeoName.Msk]: 'Moscow',
    [EGeoName.Mo]: 'MO',
    [EGeoName.Spb]: 'SPb',
    [EGeoName.Lo]: 'LO',
    [EGeoName.Other]: 'Regions',
  };

  return mapper[value];
}
